import { render } from "./WpeSelect.vue?vue&type=template&id=462059a4"
import script from "./WpeSelect.vue?vue&type=script&lang=js"
export * from "./WpeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "462059a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('462059a4', __exports__)) {
    api.reload('462059a4', __exports__)
  }
  
  module.hot.accept("./WpeSelect.vue?vue&type=template&id=462059a4", () => {
    api.rerender('462059a4', render)
  })

}


export default __exports__